import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import * as actionCreator from '../actions/actions';
import ConfirmPopup from "./popup/ConfirmPopup";
import { Device } from '../class/Device';
import * as moment from 'moment';  //Format date
import appsettings from '../appsettings';
import Toggle from 'react-toggle';
import './css/Tracker.css';
import './css/SmartHouse.css';
import { Switchs } from '../class/Switch';
import { SmartHouseUser } from '../class/SmartHouseUser';

interface Props {
    navigation: any;
    flatTarget: any;
    getSwitchList(): void;
    updateSwitch(p: Switchs): void;
    getDoorSwitch(): Switchs;
    openDoor(p: any): void;
}

interface State {
    showWrongCodeAlert: boolean;
    enteredCode: string;
    isProcessing: boolean;
    showSuccessAlert: boolean;
}

//map the props of this class to the root redux state
const mapStateToProps = (state: any) => {
    return {
        //flatList: state.flatList,
        flatTarget: state.flat,
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        //getFlatList: () => dispatch<any>(actionCreator.default.smartHouse.getFlatList()), //no tocken for this one because we use it unlogged
        openDoor: (code: any) => dispatch<any>(actionCreator.default.smartHouse.openDoorWithCode(code)),

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(class SmartHouse extends React.Component<Props, State> {
    static displayName = SmartHouse.name;
    public socket: any;

    constructor(props: any) {
        super(props);
        this.state = {
            showWrongCodeAlert: false,
            enteredCode: "",
            isProcessing: false,
            showSuccessAlert: false
        };
    };

    async componentDidMount() {
        // Smart House page is accessible without authentication
        // The door code functionality works without login
    }

    handleSetAlarm = (theSwitch: any) => {
        theSwitch.smartHouseIsActivate = !theSwitch.smartHouseIsActivate;
        this.props.updateSwitch(theSwitch);
    }

    handleKeyPress = (key: string) => {
        const { enteredCode, isProcessing } = this.state;
        
        if (isProcessing) return;

        if (key === 'clear') {
            this.setState({ enteredCode: "", showWrongCodeAlert: false });
            return;
        }

        if (key === 'delete') {
            this.setState({ enteredCode: enteredCode.slice(0, -1) });
            return;
        }

        if (enteredCode.length >= 4) return;

        const newCode = enteredCode + key;
        this.setState({ enteredCode: newCode });

        if (newCode.length === 4) {
            this.processCode(newCode);
        }
    };

    processCode = (code: string) => {
        this.setState({ isProcessing: true });
        
        // Store the current door state before making the API call
        const previousDoorState = this.props.flatTarget?.flatIsDoorOpen;
        
        this.props.openDoor(code);

        setTimeout(() => {
            const currentDoorState = this.props.flatTarget?.flatIsDoorOpen;
            
            // Check if the door state changed (indicating valid code)
            if (currentDoorState !== previousDoorState) {
                this.setState({ 
                    showSuccessAlert: true,
                    enteredCode: "",
                    isProcessing: false 
                });
            } else {
                this.setState({ 
                    showWrongCodeAlert: true,
                    enteredCode: "",
                    isProcessing: false 
                });
            }

            setTimeout(() => {
                this.setState({ 
                    showWrongCodeAlert: false,
                    showSuccessAlert: false 
                });
            }, 3000);
        }, 1000);
    };

    renderKeypadButton = (key: string, label?: string, className?: string) => (
        <button
            key={key}
            type="button"
            className={`keypad-btn ${className || ''} ${this.state.isProcessing ? 'disabled' : ''}`}
            onClick={() => this.handleKeyPress(key)}
            disabled={this.state.isProcessing}
            aria-label={`Press ${label || key}`}
        >
            {label || key}
        </button>
    );

    render() {
        const { enteredCode, isProcessing, showWrongCodeAlert, showSuccessAlert } = this.state;
        const isUnlocked = this.props.flatTarget?.flatIsDoorOpen;
        const hasValidCodeBeenEntered = showSuccessAlert || (this.props.flatTarget && this.props.flatTarget.flatIsDoorOpen !== undefined);

        return (
            <div className="smart-house-container">
                <div className="smart-house-card">
                    <div className="card-header">
                        <div className="door-status-section">
                            <div className={`door-status ${hasValidCodeBeenEntered ? (isUnlocked ? 'unlocked' : 'locked') : 'neutral'}`}>
                                <div className="status-icon">
                                    {hasValidCodeBeenEntered ? (
                                        isUnlocked ? (
                                            <i className="fas fa-unlock status-icon-unlock"></i>
                                        ) : (
                                            <i className="fas fa-lock status-icon-lock"></i>
                                        )
                                    ) : (
                                        <i className="fas fa-door-open status-icon-neutral"></i>
                                    )}
                                </div>
                                <div className="status-text">
                                    <h3>
                                        {hasValidCodeBeenEntered 
                                            ? (isUnlocked ? 'Unlocked' : 'Locked')
                                            : 'Smart Door Access'
                                        }
                                    </h3>
                                    <p>
                                        {hasValidCodeBeenEntered 
                                            ? (isUnlocked ? 'Door is open - Enter code to lock' : 'Door is locked - Enter code to unlock')
                                            : 'Enter 4-digit access code'
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Alerts */}
                        {showSuccessAlert && (
                            <div className="alert alert-success-modern" role="alert">
                                <i className="fas fa-check-circle me-2"></i>
                                Code valid! Door {isUnlocked ? 'unlocked' : 'locked'}.
                            </div>
                        )}
                        
                        {showWrongCodeAlert && (
                            <div className="alert alert-danger-modern" role="alert">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                Access denied! Wrong code entered.
                            </div>
                        )}

                        {/* Code Display */}
                        <div className="code-display">
                            <div className="code-dots">
                                {[0, 1, 2, 3].map((index) => (
                                    <div
                                        key={index}
                                        className={`code-dot ${index < enteredCode.length ? 'filled' : ''} ${isProcessing ? 'processing' : ''}`}
                                    >
                                        {index < enteredCode.length && (
                                            <i className="fas fa-circle"></i>
                                        )}
                                    </div>
                                ))}
                            </div>
                            {isProcessing && (
                                <div className="processing-text">
                                    <i className="fas fa-spinner fa-spin me-2"></i>
                                    Processing...
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="card-body">
                        <div className="keypad">
                            <div className="keypad-row">
                                {this.renderKeypadButton('1')}
                                {this.renderKeypadButton('2')}
                                {this.renderKeypadButton('3')}
                            </div>
                            <div className="keypad-row">
                                {this.renderKeypadButton('4')}
                                {this.renderKeypadButton('5')}
                                {this.renderKeypadButton('6')}
                            </div>
                            <div className="keypad-row">
                                {this.renderKeypadButton('7')}
                                {this.renderKeypadButton('8')}
                                {this.renderKeypadButton('9')}
                            </div>
                            <div className="keypad-row">
                                {this.renderKeypadButton('clear', '⌫', 'keypad-btn-action')}
                                {this.renderKeypadButton('0')}
                                {this.renderKeypadButton('delete', '✖', 'keypad-btn-action')}
                            </div>
                        </div>

                        <div className="keypad-info">
                            <div className="info-item">
                                <i className="fas fa-shield-alt me-2"></i>
                                <span>Secure Access</span>
                            </div>
                            <div className="info-item">
                                <i className="fas fa-history me-2"></i>
                                <span>Auto-lock in 30s</span>
                            </div>
                            <div className="info-item">
                                <i className="fas fa-wifi me-2"></i>
                                <span>Connected</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
});
